import Button from "@app/components/button";
import GradientContainer from "@app/components/gradient/gradient-container";
import TextGradient from "@app/components/gradient/gradient-text";
import Image from "next/image";
import { useState } from "react";

const DesktopManufacturingProcessing = ({ inView2 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="flex justify-end">
      <div className="flex w-full justify-start">
        <div className="hidden xl:block">
          <Image
            src="/images/industries/manufacturing2.png"
            alt="manufacturing"
            className="rounded-3xl"
            width={760}
            height={512}
          />
        </div>
        <div className="xl:hidden">
          <Image
            src="/images/industries/manufacturing2.png"
            alt="manufacturing"
            className="rounded-3xl"
            width={660}
            height={442}
          />
        </div>
      </div>
      <div
        className={`shadow-lg-light absolute bg-opacity-90 -mt-44 xl:-mt-32 bg-light blur-content 
          w-[45%] 2xl:w-[55%] rounded-2xl p-6 transition-opacity `}
        style={{
          visibility: inView2 ? 'visible' : 'hidden',
          transform: inView2 ? 'translateX(0%)' : 'translateX(8%)',
          transition: 'transform 500ms ease-in',
          // opacity: inView2 ? 0.9 : 0,
        }}
      >
        <div
          className={`flex flex-col ml-2 space-y-5
           ${isExpanded ? 'h-[620px] xl:h-[605px] xl-2:!h-[540px] 2xl:!h-[450px]' : 'h-[455px] xl:h-[465px] xl-2:!h-[420px] 2xl:!h-[360px]'}
           transition-[height] ease-in-out duration-500`}
        >
          <TextGradient>
            <p className="h2">02</p>
          </TextGradient>
          <p className="h4 xl:h3 text-background-primary-dark">Manufacturing & Food Processing</p>
          <div>
            <GradientContainer overrideClassName="w-[40%] h-2" />
          </div>
          <div className=" text-text-color-mid-em-light space-y-5">
            <p>
              SimpleWaste represents all sectors of the manufacturing industry.
            </p>
            <p>
              Our platform combines technology, procurement,
              and operations support providing your management teams the tools they require for
              streamlined service delivery with 100% transparency.
            </p>
            {isExpanded &&
              <div className="space-y-5">
                <p>
                  At SimpleWaste we design effective solutions that flow seamlessly within
                  your operational footprint. Waste stream management and equipment
                  optimization are essential for collecting and handling the unique
                  waste profiles generated from the industry.
                </p>
              </div>
            }
          </div>
          <div className="flex h-full items-end">
            <div>
              <Button onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? 'Read less' : 'Read more'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DesktopManufacturingProcessing;
